var map = {
	"./apple.png": 6832,
	"./bar.png": 2998,
	"./bell.png": 8814,
	"./board.png": 1842,
	"./decrease.png": 7647,
	"./god_1.png": 2086,
	"./god_10.png": 4641,
	"./god_11.png": 6463,
	"./god_12.png": 3187,
	"./god_13.png": 905,
	"./god_14.png": 2773,
	"./god_15.png": 2637,
	"./god_16.png": 4744,
	"./god_17.png": 5246,
	"./god_2.png": 6645,
	"./god_3.png": 5316,
	"./god_4.png": 5978,
	"./god_5.png": 5429,
	"./god_6.png": 7771,
	"./god_7.png": 7737,
	"./god_8.png": 9074,
	"./god_9.png": 9277,
	"./increase.png": 9538,
	"./lucky_bag2.png": 9187,
	"./lucky_bag3.png": 4803,
	"./lucky_bag4.png": 4282,
	"./lucky_bag5.png": 3757,
	"./lucky_thing1.png": 6349,
	"./lucky_thing2.png": 1748,
	"./lucky_thing3.png": 958,
	"./lucky_thing4.png": 7822,
	"./lucky_thing5.png": 4366,
	"./lucky_thing6.png": 4370,
	"./melon.png": 1853,
	"./orange.png": 7339,
	"./seven.png": 8047,
	"./star.png": 1258,
	"./watermelon.png": 1854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1150;